import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { chunk, isEmpty, times } from 'lodash';

import {
  RecordsWithTimestamp,
  SearchInstanceDto,
  TimestampedRecordWithData,
} from '@app/components';
import { axios } from '@app/utils';
import { isTestEnv } from '@app/constants';

const batchAmount = isTestEnv ? 3 : 50;

export const useBatchInstancesFetch = ({
  queryKey,
  list = [],
}: {
  queryKey: string;
  list?: RecordsWithTimestamp[];
}): UseQueryResult<TimestampedRecordWithData[]> => {
  const fetchItems = async () => {
    const listChunks = chunk(list, batchAmount);

    const responses = await Promise.all(
      times(listChunks.length, index =>
        axios.post<SearchInstanceDto[]>(
          '/opac-inventory/instances/batch-enrichment',
          listChunks[index].map(record => record.instanceId)
        )
      )
    );

    return responses.reduce((recordsData, response, chunkIndex) => {
      const currentChunkResponse = response.data;
      const currentViewedRecordsChunk = listChunks[chunkIndex];

      const recordsWithTimestamp = currentViewedRecordsChunk.map(record => ({
        ...currentChunkResponse.find(({ id }) => id === record.instanceId),
        ...record,
      }));

      return [...recordsData, ...recordsWithTimestamp];
    }, []);
  };

  return useQuery(['instancesBatch', queryKey, list], fetchItems, {
    enabled: !isEmpty(list),
  });
};
